<template>
  <v-container
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      wrap
    >
      <v-flex
        md7
        xs12
      >
        <ref-board />
      </v-flex>
      <v-flex
        md5
        xs12
      >
        <aff-stats />
      </v-flex>

      <v-flex
        xs12
        md7
      >
        <aff-profile />
      </v-flex>
      <v-flex
        xs12
        md5
      >
        <ref-links />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import AffProfile from "@/views/Affiliates/partial/AffProfile.vue";
import RefBoard from "@/views/Affiliates/partial/RefBoard.vue";
import AffStats from "@/views/Affiliates/partial/AffStats.vue";
import RefLinks from "@/views/Affiliates/partial/RefLinks.vue";

export default {
  name: "Affiliate",
  components: {
    RefBoard,
    AffProfile,
    AffStats,
    RefLinks,
  },
  data() {
    return {
      loading: false,
    };
  }
};
</script>

<style lang="scss" >
.internal_balnce {
  &.xs {
    font-size: 12px !important;
    b {
      font-size: 16px !important;
    }
    .flex {
      padding: 0 !important;
    }
  }
  .flex {
    text-align: center;
    b {
      font-size: 22px;
    }
  }
}
</style>
